export default "__VITE_ASSET__DgLSTV6g__"